import validator from "validator";
import { UpdateVersionPayload } from "../../types/system/system";

export const validateUpdateVersionPayload = (
  versionInput: UpdateVersionPayload
) => {
  const updateUrl = validator.isEmpty(versionInput.updateUrl);
  const forceUpdateVersionName = validator.isEmpty(
    versionInput.forceUpdateVersionName
  );
  const versionName = validator.isEmpty(versionInput.versionName);

  return {
    hasError: updateUrl || forceUpdateVersionName || versionName,
    validationResults: {
      updateUrl,
      forceUpdateVersionName,
      versionName,
    },
  };
};
